import Vue from "vue";
import Vuex from "vuex";
import ApiWrapper from "../utils/Api";
import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);

/* NOTE: Updated to the live URL via the `setPlaceInfo` mutation! */
export const Api = new ApiWrapper("https://api.uat.sawdays.co.uk/");

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions
});
